import moment from 'moment';
import { bookingApi } from 'services/http';

// Services
import { alertError } from 'services/alerts';
import { dateForRequest } from 'services/date';


// mockData
// import { testAppointmentsVerdonk } from 'src/__mock__/UG';


export const loadAppointsByDocIdAndDate = async (doctorId, date) => {
  // return testAppointmentsVerdonk;
  if (doctorId && date) {
    return bookingApi
      .get(`practitioners/${doctorId}/bookings`, {
        params: {
          startDateTime: dateForRequest(moment(date).startOf('day')),
          endDateTime: dateForRequest(moment(date).endOf('day'))
        },
        withoutLoader: true
      })
      .then(({ data }) => {
        if (Array.isArray(data)) {
          return data.sort((a, b) => new Date(a.dateTime) - new Date(b.dateTime));
        }
        return data;
      })
      .catch((err) => {
        const { response } = err;
        if (response && response.status !== 400 && response.status !== 401) {
          alertError();
        } else {
          throw Error(err);
        }
      });
  }
  throw Error('invalid input data');
};